var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.605 0.398878L20.3584 7.65087C20.7636 7.98896 21 8.48661 21 9.01845V19.2335C21 20.206 20.2158 21 19.2553 21H14.0025C13.5335 21 13.0983 20.8177 12.7681 20.4834C12.4379 20.1491 12.2578 19.7046 12.2578 19.2335V13.03C12.2578 13.0262 12.2541 13.0224 12.2503 13.0224H8.74969C8.74594 13.0224 8.74218 13.0262 8.74218 13.03V19.2335C8.74218 19.7046 8.56209 20.1491 8.23191 20.4834C7.90173 20.8177 7.46275 21 6.9975 21H1.74468C0.78417 21 0 20.206 0 19.2335V9.01845C0 8.48661 0.232625 7.98896 0.637842 7.65087L9.39503 0.398878C10.0366 -0.132959 10.9634 -0.132959 11.605 0.398878Z",
    fill: "#424242"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.605 0.398878L20.3584 7.65087C20.7636 7.98896 21 8.48661 21 9.01845V19.2335C21 20.206 20.2158 21 19.2553 21H14.0025C13.5335 21 13.0983 20.8177 12.7681 20.4834C12.4379 20.1491 12.2578 19.7046 12.2578 19.2335V13.03C12.2578 13.0262 12.2541 13.0224 12.2503 13.0224H8.74969C8.74594 13.0224 8.74218 13.0262 8.74218 13.03V19.2335C8.74218 19.7046 8.56209 20.1491 8.23191 20.4834C7.90173 20.8177 7.46275 21 6.9975 21H1.74468C0.78417 21 0 20.206 0 19.2335V9.01845C0 8.48661 0.232625 7.98896 0.637842 7.65087L9.39503 0.398878C10.0366 -0.132959 10.9634 -0.132959 11.605 0.398878Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.5a2413be1a84af3cc358c0e91f88adda.svg";
export { ForwardRef as ReactComponent };